import { EDGE_RIGHTSHOLDER_ATTRIBUTION } from '@app/constants/config';
import type { Client } from '../types/api';

export type RhAttributionPostQueryFields = {
    useRightsholderAttribution: boolean;
};

/**
 * Same rules as getSendData / SRS report payload: only when the client has RH
 * attribution permission and a mode is selected; true in league mode, false in team mode.
 */
export function rhAttributionPostQueryFields(
    client?: Pick<Client, 'permissions'> | null,
    rightsholderAttribution?: string | null,
): RhAttributionPostQueryFields | Record<string, never> {
    const hasRhAttributionPermission =
        client?.permissions?.includes(EDGE_RIGHTSHOLDER_ATTRIBUTION) ?? false;
    if (!hasRhAttributionPermission || !rightsholderAttribution) {
        return {};
    }
    return {
        useRightsholderAttribution: rightsholderAttribution == 'league',
    };
}
